module.exports = __webpack_public_path__ + "infocentrum21.jpg?65c90e04d7e87bb2c84f3fe3663ef38d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/reference/infocentrum/infocentrum21.jpg
// module id = 273
// module chunks = 0